import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'

import {
    DoDriverSearchParamsT,
    DoDriverSearchResponse,
    SecurityGetAutoInformationResponseT,
    SecurityGetCheckupStatusParams,
    SecurityGetCheckupStatusResponseT,
    SecurityGetCompanyInformationResponseT,
    SecurityGetPersonInformationResponseT,
    SecurityGetSbHistoryResponse,
    SecurityHistoryParamsT,
} from '../types/security.types'

export class SecurityRepository {
    getPersonInformation(
        person_iin: string
    ): Promise<AxiosResponse<SecurityGetPersonInformationResponseT>> {
        return http.get(`/contract/api/adata/person/${person_iin}`)
    }

    createPersonInformationRequest(person_iin: string): Promise<AxiosResponse<void>> {
        return http.post(`/contract/api/adata/person`, {
            iin: person_iin,
        })
    }

    getCompanyInformation(
        company_bin: string
    ): Promise<AxiosResponse<SecurityGetCompanyInformationResponseT>> {
        return http.get(`/contract/api/adata/company/${company_bin}`)
    }

    createCompanyInformationRequest(company_bin: string): Promise<AxiosResponse<void>> {
        return http.post('/contract/api/adata/company', {
            companyBin: company_bin,
        })
    }

    getAutoInformation(
        number: string
    ): Promise<AxiosResponse<SecurityGetAutoInformationResponseT>> {
        return http.get(`/contract/api/adata/car/${number}`)
    }

    createAutoInformationRequest(
        number: string,
        technical_passport: string
    ): Promise<AxiosResponse<void>> {
        return http.post('/contract/api/adata/car', {
            gosNumber: number,
            techNumber: technical_passport,
        })
    }

    setCheckupAccept(
        identifier: string,
        type: number,
        comment: string | null
    ): Promise<AxiosResponse<void>> {
        return http.post('/contract/api/checkup/accept', {
            identifier,
            type,
            comment,
        })
    }

    setCheckupReject(
        identifier: string,
        type: number,
        comment: string
    ): Promise<AxiosResponse<void>> {
        return http.post('/contract/api/checkup/reject', {
            identifier,
            type,
            comment,
        })
    }

    getCheckupStatus(
        params: SecurityGetCheckupStatusParams
    ): Promise<AxiosResponse<SecurityGetCheckupStatusResponseT>> {
        return http.get('/contract/api/checkup/check', { params })
    }

    getSbHistory(
        params: SecurityHistoryParamsT
    ): Promise<AxiosResponse<SecurityGetSbHistoryResponse>> {
        return http.get('/contract/api/checkup/history', { params })
    }

    doDriverSearch(params: DoDriverSearchParamsT): Promise<AxiosResponse<DoDriverSearchResponse>> {
        return http.get('/cabinet/api/drivers/search', { params })
    }
}
